import React from "react";
import {IndicatorsContext} from "./project-indicators-context-props.ts";

const useProjectIndicatorsContext = () => {
    const indicatorsContext = React.useContext(IndicatorsContext);
    if (indicatorsContext === undefined) {
        throw new Error('useProjectIndicatorsContext must be used within a ProjectIndicatorsProvider');
    }
    return indicatorsContext;
};

export default useProjectIndicatorsContext;